import notification from './../../notification'

export default {
  data () {
    return {
      training: {},
      formErrors: {},
    }
  },
  methods: {
    createTraining () {
      this.$vs.loading()
      const formData = new FormData()
      formData.append('name', this.training.name)
      formData.append('description', this.training.description)
      formData.append('thumbnail', this.training.thumbnail)
      for (let i = 0; i < this.allowedUserPositionList.length; i++) {
        formData.append('allowed_user_positions[]', this.allowedUserPositionList[i])
      }
      this.$store.dispatch('trainings/createTraining', formData)
        .then((response) => {
          this.$vs.notify(notification.success('Szkolenie zostało dodane'))
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 422) {
              this.formErrors =  error.response.data.errors
            } else {
              this.$vs.notify(notification.error(error.message))
            }
          }
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
  }
}
